import { render, staticRenderFns } from "./ModalFormDocumentClient.vue?vue&type=template&id=474dd292&"
import script from "./ModalFormDocumentClient.vue?vue&type=script&lang=js&"
export * from "./ModalFormDocumentClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormDocumentClient.vue?vue&type=style&index=0&id=474dd292&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474dd292')) {
      api.createRecord('474dd292', component.options)
    } else {
      api.reload('474dd292', component.options)
    }
    module.hot.accept("./ModalFormDocumentClient.vue?vue&type=template&id=474dd292&", function () {
      api.rerender('474dd292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalFormDocumentClient.vue"
export default component.exports